var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMillRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V5H16V3H8V5H6V3H4V19C4 20.1046 4.89543 21 6 21H8H16H18C19.1046 21 20 20.1046 20 19V3H18ZM8 17H6V15H8V17ZM8 13H6V11H8V13ZM8 9H6V7H8V9ZM14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17V5H14V17ZM18 17H16V15H18V17ZM18 13H16V11H18V13ZM18 9H16V7H18V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillRaw);
export default __webpack_public_path__ + "static/media/MillRaw.d62efbacd53130680a5c21cc8420bbc1.svg";
export { ForwardRef as ReactComponent };